import React from 'react';
import { ScrollArea } from '@/components/ui/scroll-area';
import { InboxIcon, FolderIcon, SendIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';

export type Section = {
  folder: string;
  filter: string;
};

export type SidebarProps = {
  onChangeSection: (section: Section) => void;
  currentSection: Section;
  user: {
    folders: string[];
    rules: string[];
  };
};

export const Sidebar: React.FC<SidebarProps> = ({ onChangeSection, currentSection, user }) => {
  const { folder, filter } = currentSection;
  const isInbox = folder === 'inbox';
  const isUnread =  filter === 'unread';
  const isAll = filter === 'all';

  return (
    <div className="h-screen w-52 border-r bg-white flex flex-col">
      <div className="flex-1 px-4 py-6">
        {/* Unread/All Toggle Pill - only for Inbox */}
      
          <div className="flex p-1 bg-gray-100 rounded-lg mb-4">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onChangeSection({ ...currentSection, filter: 'unread' })}
              className={`flex-1 h-7 text-xs ${isUnread ? 'bg-white shadow-sm text-blue-600 hover:bg-white' : 'text-gray-500 hover:text-gray-900'}`}
            >
              Unread
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onChangeSection({ ...currentSection, filter: 'all' })}
              className={`flex-1 h-7 text-xs ${isAll ? 'bg-white shadow-sm text-blue-600 hover:bg-white' : 'text-gray-500 hover:text-gray-900'}`}
            >
              All
            </Button>
          </div>
       

        {/* Inbox Section Label */}
    

        <Button                 
          variant={folder === 'inbox' ? "secondary" : "ghost"}
          onClick={() => onChangeSection({ ...currentSection, folder: 'inbox'})}
          className="w-full justify-start mb-1"
        >
          <InboxIcon className="h-4 w-4 mr-2" />
          Inbox
        </Button>

        {/* Folders Section */}
        {user.folders.length > 0 && (
          <div className="mb-6 ml-3 border-l pl-2 mt-2 space-y-1">
            {user.folders.map((folderName: string) => (
              <Button
                key={folderName}
                variant={folder === folderName ? "secondary" : "ghost"}
                size="sm"
                onClick={() => onChangeSection({ ...currentSection, folder: folderName})}
                className="w-full justify-start h-8 text-sm font-normal"
              >
                <FolderIcon className="h-3 w-3 mr-2 text-gray-400" />
                {folderName}
              </Button>
            ))}
          </div>
        )}

        {/* Sent Section */}
        <Button
          variant={folder === 'sent' ? "secondary" : "ghost"}
          onClick={() => onChangeSection({ ...currentSection, folder: 'sent'})}
          className="w-full justify-start mt-1"
        >
          <SendIcon className="h-4 w-4 mr-2" />
          Sent
        </Button>
      </div>
    </div>
  );
};
